
require('../../assets/js/bootstrap');

import { createApp, h } from 'vue';
import {createInertiaApp, Head, Link} from '@inertiajs/vue3';
import { createGettext } from '@jshmrtn/vue3-gettext';
import SvgVue from 'svg-vue3';
import translations from '../../lang/translations.json';
import moment from 'moment-business-days';
import VueTippy from 'vue-tippy';


createInertiaApp({
    title: title => `${title} - PART FACTORY`,
    resolve: name => require(`../../vue/Pages/Admin/${name}`),
    setup({ el, App, props, plugin }) {
        const VueApp = createApp({ render: () => h(App, props) });
        const gettext = createGettext({
            availableLanguages: {
                en: 'English',
                de: 'Deutsch',
            },
            defaultLanguage: window._locale ? window._locale : 'de',
            mutedLanguages: ['de'],
            translations,
            silent: true,
        });

        VueApp.directive('sticky', {
            mounted(el) {
                const observerHeader = new IntersectionObserver(
                    ([e]) => {
                        e.target.classList.toggle('sticky', e.intersectionRatio < 1);
                    },
                    {threshold: 1}
                );
                observerHeader.observe(el);
            },
        });

        VueApp.use(plugin)
            .use(gettext)
            .use(SvgVue)
            .use(VueTippy)
            .component('Head', Head)
            .component('Link', Link)
            .mixin(require('../../assets/js/base'));

        moment.updateLocale('de', {
            holidays: props.initialPage.props.holidays,
            holidayFormat: 'YYYY-MM-DD',
        });

        VueApp.config.globalProperties.$moment = moment;

        VueApp.mount(el);


    },
});


// resolve: async (name) => {
//     const pages = import.meta.glob('./Pages/**/*.vue');
//
//     return (await pages[`./Pages/${name}.value`]()).default;
// },
